import {make} from 'vuex-pathify'
import router from "@/router";
import {
  getTripleIResultApi,
  getSBBuildingAverageApi,
  getSBCombinePremiumApi,
  postSBResultApi,
  getSBResultApi,
  updateSBResultApi
} from "@/func/api";

const state = function () {
  return {
    postData: {},
    plan: {},
    token: '',
    isEmpty: false,
    formData: {
      alreadyPrepare: 0,
      gender: "",
      currentAge: 0,
      birthdayY: 0,
      birthdayM: 0,
      birthdayD: 0,
      isFirst: false,
      yearGetBack: 0
    },
    tripleIData: {
      gender: '',
      age: 0,
      saveAmountPerMonth: 0,
      yearGetBack: 0,
      t_currency: '',
      t_amount: 0,
      t_productName: '',
      t_payYear: 0,
      t_getAmount: 0,
      u_currency: '',
      u_amount: 0,
      u_productName: '',
      u_payYear: 0,
      u_getAmount: 0,
      errorMessage: []
    },
    result: {
      hasData: false,
      totalPayment: 0,
      downPayment: 0,
      downPaymentStillNeed: 0,
      suggestSavePerMoney: 0,
      achievementRate: 0,
      alreadyPrepare: 0,
    },
    buildingAverage: 0,
    premium_1: 0,
    premium_2: 0,
    data: [],
  }
}

const mutations = make.mutations(state)
const actions = {
  ...make.actions([
    'postData',
    'formData',
    'result',
    'token',
    'buildingAverage',
    'tripleIData',
    'plan',
    'data'
  ]),
  setPostData(context, {page_no, page_answer}) {
    let postData = context.state.postData
    postData[page_no] = page_answer
    context.commit('postData', postData)
  },
  async sendTripleIBuyHouseApi({state, getters, commit}) {
    // Get 3iii 結果頁資料
    let data = {
      gender: state.formData.gender,
      Age: state.formData.currentAge,
      saveAmountPerMonth: state.formData.yearGetBack <= 6 &&
                          state.formData.alreadyPrepare > 100000 ?
                          state.formData.alreadyPrepare / 12 :
                          getters.suggestSavePerMoney,
      yearGetBack: state.formData.yearGetBack
    }
    const res = await getTripleIResultApi(data)
    commit('tripleIData', res.data)
  },
  async sendSBBuildingAverageApi({state, commit}) {
    let data = {
      county: state.postData[3].county,
      city: state.postData[3].city,
      building_type: state.postData[4].value
    }
    const res = await getSBBuildingAverageApi(data)
    commit('buildingAverage', Math.round(res.data))
  },
  async sendSBCombinePremiumApi({state, commit}) {
    let premium_1_data = {
      gender: state.formData.gender === "MALE" ? 1 : 2,
      age: state.formData.currentAge,
      job: 1,
      id: state.formData.currentAge < 45 ?
        '70bdb9ef4a7a7cd1b1c009ae1667b146' :
        '7feadebcb61c2dc39a74e38df307d830',
    }
    let premium_2_data = {
      gender: state.formData.gender === "MALE" ? 1 : 2,
      age: state.formData.currentAge,
      job: 1,
      id: '7116ec4f16016a88d94bb8f1934f8f82',
    }

    const premium_1 = await getSBCombinePremiumApi(premium_1_data)
    const premium_2 = await getSBCombinePremiumApi(premium_2_data)
    commit('premium_1', premium_1.data)
    commit('premium_2', premium_2.data)
  },
  setResultData({commit, getters, state}) {
    let result = {
      hasData: true,
      plan: state.plan,
      buildingAverage: state.buildingAverage,
      postData: state.postData,
      formData: state.formData,
      tripleIData: state.tripleIData,
      totalPayment: getters.totalPayment,
      downPayment: getters.downPayment,
      downPaymentStillNeed: getters.downPaymentStillNeed,
      suggestSavePerMoney: getters.suggestSavePerMoney,
      achievementRate: getters.achievementRate,
      alreadyPrepare: state.formData.alreadyPrepare,
      yearGetBack: state.tripleIData.yearGetBack,
      t_returnRate: getters.t_returnRate,
      t_saveInRowYear: state.tripleIData.t_payYear,
      t_saveInRowAmount: state.tripleIData.t_amount,
      t_getAmount: state.tripleIData.t_getAmount,
      t_raisedAchievementRate: getters.t_raisedAchievementRate,
      u_returnRate: getters.u_returnRate,
      u_saveInRowYear: state.tripleIData.t_payYear,
      u_saveInRowAmount: state.tripleIData.t_amount,
      u_getAmount: state.tripleIData.u_getAmount,
      u_raisedAchievementRate: getters.u_raisedAchievementRate,
      premium_1: state.premium_1,
      premium_2: state.premium_2,
    }
    commit('result', result)
  },
  async saveSBBuyHouseData({state, commit}) {
    let data = {
      a_json_data: state.result
    }
    const res = await postSBResultApi(data)
    commit('token', res.data.data.a_uniqid)
  },
  async getSBBuyHouseData({state, commit}, payload) {
    const res = await getSBResultApi(payload)
    let data = JSON.parse(res.data.data.a_json_data)
    commit('result', data)
    commit('buildingAverage', data.buildingAverage)
    commit('postData', data.postData)
    commit('formData', data.formData)
    commit('tripleIData', data.tripleIData)
    commit('premium_1', data.premium_1)
    commit('premium_2', data.premium_2)
  },
  async updateSBBuyHouseData({state, commit, dispatch}, {value, token, planObj}) {
    if (value) {
      let postData = state.postData
      postData[6] = value
      await commit('postData', postData)
    }

    if (planObj) await commit('plan', planObj)

    await dispatch('sendTripleIBuyHouseApi')
    await dispatch('setResultData')

    let data = {
      a_json_data: state.result,
      a_uniqid: token
    }
    const res = await updateSBResultApi(data)

    if (res.data.status === 200 && planObj)
      document.location.href = (`/form/order/needs_analysis/real_estate?tk=${token}`);

    if (res.data.status !== 200) {
      alert('好像遇到麻煩囉！請重新操作')
      await router.push({name: 'buyHouse'})
    }
  }
}

const getters = {
  totalPayment(state, getters) {
    return parseInt((state.postData[1].value *
        getters.nineSquareDivisionMaxValue *
        state.buildingAverage *
        state.postData[5].value) +
      state.postData[6])
  },
  downPayment(state, getters) {
    let isFirstValue = state.formData.isFirst === true ? 0.2 : 0.3
    return parseInt((state.postData[1].value *
        getters.nineSquareDivisionMaxValue *
        state.buildingAverage *
        state.postData[5].value *
        isFirstValue) +
      state.postData[6])
  },
  downPaymentStillNeed(state, getters) {
    let downPaymentStillNeed = Math.round(getters.downPayment - state.formData.alreadyPrepare)
    return downPaymentStillNeed > 0 ? downPaymentStillNeed : 0
  },
  suggestSavePerMoney(state, getters) {
    let suggestSavePerMoney = Math.round(
      (getters.downPayment - state.formData.alreadyPrepare) /
      (state.formData.yearGetBack * 12)
    )
    return suggestSavePerMoney > 0 ? suggestSavePerMoney : 0
  },
  achievementRate(state, getters) {
    return Math.floor((state.formData.alreadyPrepare / getters.downPayment) * 100)
  },
  nineSquareDivisionMaxValue(state) {
    let max = 0
    state.postData[2].forEach(item => {
      if (item.value > max) max = item.value
    })
    return max
  },
  t_returnRate(state) {
    //報酬率(%)＝{ ( t_getAmount - t_amount * t_payYear ) / ( t_amount * t_payYear ) } * 100
    return Math.ceil((state.tripleIData.t_getAmount -
        state.tripleIData.t_amount * state.tripleIData.t_payYear) * 100 /
      (state.tripleIData.t_amount * state.tripleIData.t_payYear))
  },
  t_raisedAchievementRate(state, getters) {
    return Math.ceil((state.tripleIData.t_getAmount -
        state.tripleIData.t_amount * state.tripleIData.t_payYear) * 100 /
      getters.downPayment)
  },
  u_returnRate(state) {
    //報酬率(%)＝{ ( u_getAmount - u_amount * u_payYear ) / ( u_amount * u_payYear ) } * 100
    return Math.ceil((state.tripleIData.u_getAmount -
        state.tripleIData.u_amount * state.tripleIData.u_payYear) * 100 * 28.5 /
      (state.tripleIData.u_amount * state.tripleIData.u_payYear * 28.5))
  },
  u_raisedAchievementRate(state, getters) {
    return Math.ceil((state.tripleIData.u_getAmount -
        state.tripleIData.u_amount * state.tripleIData.u_payYear) * 100 * 28.5 /
      getters.downPayment)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
